var React = require('react');

function CloudBig (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,62.000000) scale(0.100000,-0.100000)","fill":"#ffffff","stroke":"none"},React.createElement("path",{"d":"M636 599 c-98 -16 -176 -63 -221 -135 -19 -29 -33 -43 -44 -40 -126\n37 -257 -12 -309 -114 -26 -52 -28 -96 -7 -148 22 -51 52 -81 110 -108 l50\n-24 438 0 c478 0 476 0 531 59 41 43 48 121 14 170 -29 43 -79 73 -133 81 -38\n5 -41 7 -57 57 -21 67 -58 114 -116 151 -77 48 -165 66 -256 51z"})));
}

CloudBig.defaultProps = {"version":"1.0","width":"126.000000pt","height":"62.000000pt","viewBox":"0 0 126.000000 62.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = CloudBig;

CloudBig.default = CloudBig;
